<template>
  <div id="app">
    <router-view v-if="!lock"/>
    <div class="version-lock" v-else>
      <h4>Ваша версия устарела</h4>
      <p>У нас появились критические обновления, пожалуйста обновите приложение до последней версии</p>
    </div>
    <div class="version">{{ VERSION }}</div>
    <!--    <button @click="sendTest">Send</button>-->
    <!--    <button @click="createReportTest">Create Report</button>-->
    <!--    <button @click="getTables">Get tabels</button>-->
    <!--    <button @click="tetPut">List </button>-->

  </div>
</template>

<script>
import firebase from 'firebase';
import {apiAuthUrl, apiUrl, isCache} from "./plugins/firebase";
import axios from "axios";

const VERSION = 7.5;


export default {
  name: 'App',

  data() {
    return {
      init: false,
      lock: false,
      VERSION,
    };
  },

  watch: {
    '$store.state.project.id': {
      async handler() {
        if (this.$store.state.project.id) {
          const authProxy = await axios.post(apiAuthUrl, {
            uid: firebase.auth().currentUser.uid,
            projectId: this.$store.state.project.id
          });

          localStorage.setItem('api-token', authProxy.data.token)
        }
      },
      immediate: true,
      deep: true,
    },
    '$route.params': {
      async handler() {
        if (this.$store.state.project.id) {
          this.$router.replace({
            name: this.$route.name,
            params: {
              ...this.$route.params,
            },
            query: {
              ...this.$route.query,
              project: this.$store.state.project.id,
            },
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
  },
  beforeCreate() {
    const currentServer = localStorage.getItem('server')

    if (currentServer === 'lk' && !window.location.pathname.includes(currentServer)) {
      window.location.href = '/lk/index.html'
    } else if (currentServer === 'rk' && !window.location.pathname.includes(currentServer)) {
      window.location.href = '/local/index.html'
    } else if (currentServer === 'main' && window.location.pathname.includes(currentServer)) {
      window.location.href = '/'
    }

    firebase.functions().customDomain = apiUrl
    this.$store.dispatch('setUser');
    firebase.firestore()
      .collection('versions')
      .get().then((response) => {
      const result = [];
      response.forEach((d) => result.push(d.data()));
      const version = result[result.length - 1];
      if (version.required && version.updates > VERSION) {
        this.lock = true;
      }
    }).catch((e) => {
      console.log(e)
      window.URL_FIREBASE_APIS = 'proxy-firebase.stroybots.ru'
      // window.URL_FIREBASE = 'firestore.googleapis.com'
      window.URL_WWW_GOOGLEAPIS = 'proxy-apis-firebase.stroybots.ru'
    });
  },
};
</script>

<style lang="scss">

.show-link-message {
  max-width: 380px;
  background: #fff !important;
  .el-message__content {
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000 !important;
  }

  .el-message__icon.el-icon-info {
    display: none;
  }

  .el-icon-link {
    font-size: 22px;
    font-weight: bold;
    cursor: pointer;
    margin-right: 10px;
  }
}

.firebase-emulator-warning {
  display: none !important;
}

input:disabled {
  color: #000000 !important;
  opacity: 1 !important;
}

textarea:disabled {
  color: #000000 !important;
  opacity: 1 !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
  -moz-appearance: textfield; /* Firefox */
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.error {
  color: #c0392b;
  text-align: center;
  margin: -5px auto 15px auto;
}

body {
  padding: 0;
  margin: 0;
}

.el-table__row {
  cursor: pointer;
}

.el-checkbox {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .el-checkbox__input {
    white-space: normal !important;
  }

  .el-checkbox__label {
    text-align: left;
    white-space: normal !important;
  }
}

.el-dialog {
  width: 50%;
  max-width: 522px;
  @media screen and (max-width: 764px) {
    width: 100% !important;
  }
}

.el-message-box {
  max-width: 420px !important;
  width: 100% !important;

  @media screen and (max-width: 764px) {
    margin-top: 50px !important;
  }
}

.version {
  position: fixed;
  font-size: 12px;
  bottom: 1px;
  right: 4px;
}


::placeholder, .multiselect__placeholder {
  color: #4b5e70 !important;
}

input, textarea, .multiselect__single {
  color: #0e1011 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}

.multiselect__tag {
  white-space: normal !important;

  span {
    font-size: 16px !important;
    font-weight: 500 !important;
  }
}

label {
  font-weight: bold !important;
  color: #000 !important;
}

.mx-datepicker-main {
  z-index: 9999 !important;
}

.multiselect__content {
  width: 100% !important;
}

.multiselect__content-wrapper {
  overflow-x: hidden !important;

  .multiselect__option {
    overflow-wrap: anywhere !important;
    white-space: unset !important;
  }
}

.version-lock {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
}

.inline-btn {
  border: none;
  background: rgba(0, 0, 0, 0) !important;
  color: #000;
  display: inline-block;
  width: auto;

  &:hover {
    text-decoration: underline;
  }
}

.el-input__prefix, .el-input__suffix {
  color: #000;
  cursor: pointer;
}

.flex {
  display: flex;
}

.flex-1 {
  flex: 1;
}

.align {
  align-items: center;
}

.space-between {
  justify-content: space-between !important;
}

.volumes .el-dialog__wrapper {
  z-index: 9999999 !important;
}

.volumes-multiple .el-dialog__wrapper {
  background: rgba(0, 0, 0, 0.35);
  z-index: 99999991 !important;
}

.mx-datepicker-main {
  z-index: 99999992 !important;
}

.create-new-jobs {
  width: calc(100% - 20px) !important;
  max-width: 372px !important;

  .el-dialog__body {
    padding: 0 12px;
  }

  .report-add-job {
    margin-top: 10px !important;
    padding-top: 0 !important;
    border-top: none !important;
  }

  .el-dialog__close {
    top: 16px;
    right: 16px;
  }
}

.multiselect__single {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

input, button {
  outline: none !important;
}

.icon-menu {
  width: 18px;
}

@media screen and (max-width: 700px) {
  .multiselect__tags {
    padding-right: 10px !important;
  }

  .multiselect__select {
    width: 25px !important;
    z-index: 99 !important;
  }

  .multiselect__tag-icon {
    margin-left: 0 !important;
  }
}

.add-job button {
  width: 100%;
  margin-top: 12px;
}
</style>





// WEBPACK FOOTER //
// src/App.vue